module.exports = __webpack_public_path__ + "static/img/Trust-waratah-colour-small.7fd66c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Trust-waratah-colour-small.png
// module id = I6Jg
// module chunks = 1